<template>
  <router-view />
</template>

<script lang="ts">
export default {};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
</style>
